var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ErrorView',{ref:"errorView"}),_vm._v(" "),(_vm.playlist)?_c('PlaylistResult',{attrs:{"items":_vm.playlist}}):(_vm.resultDefault)?_c('ResultDefault',{attrs:{"data":_vm.resultDefault}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }